import React from 'react';
import Modal from '@xpeng/react-modal';

import './index.scss';

let loading: { destroy: () => void } | null = null;

const getModal = (content: React.ReactNode, zIndex: number) => {
  loading = Modal.popup({
    children: content,
    isOpened: true,
    isMask: false,
    isLock: false,
    closeOnClickOverlay: false,
    zIndex,
    onHide: () => { },
  });
};

export default {
  show: (text: string = '', zIndex: number = 999) => {
    const content = (
      <div className="c-com-loading-container">
        <div className="com-loading-img" />
        {
          !!text && (
            <div className="com-loading-text">{text}</div>
          )
        }
      </div>
    );
    if (loading) {
      loading.destroy();
      loading = null;
    }
    getModal(content, zIndex);
  },
  hide: () => {
    if (loading) {
      loading.destroy();
      loading = null;
    }
  },
};

// 绿色小 loading 块
export function CommonLoadingComp(props) {
  const { text } = props;
  return (
    <div className="c-com-loading-container">
      <div className="com-loading-img" />
      {
        !!text && (
          <div className="com-loading-text">{text}</div>
        )
      }
    </div>
  );
}